import { render, staticRenderFns } from "./NewContactEmailDialog.vue?vue&type=template&id=38122b82"
import script from "./NewContactEmailDialog.vue?vue&type=script&lang=js"
export * from "./NewContactEmailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports